// Single source of truth for API base.
// DEV: localhost backend unless VITE_API_BASE is set.
// PROD: same-origin (empty string) so Vercel rewrites /api/* to Railway.
//       Never allow localhost overrides in production builds.

let API_BASE: string;
const IS_DEVELOPMENT_MODE = import.meta.env.MODE === 'development';

function isLocalhostApiUrl(value: string): boolean {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.hostname === 'localhost' || url.hostname === '127.0.0.1';
  } catch {
    return /localhost|127\.0\.0\.1/.test(value);
  }
}

function readApiBaseOverride(): string {
  const raw = import.meta.env.VITE_API_BASE;
  return typeof raw === 'string' ? raw.trim() : '';
}

if (!IS_DEVELOPMENT_MODE) {
  const override = readApiBaseOverride();
  if (override && !isLocalhostApiUrl(override)) {
    API_BASE = override;
  } else {
    API_BASE = '';
    if (override && isLocalhostApiUrl(override)) {
      console.error('[API_BASE] Refusing localhost VITE_API_BASE in production — using same-origin /api');
    }
  }
} else {
  API_BASE = readApiBaseOverride() || 'http://localhost:8080';
}

console.log('[API_BASE] Resolved to:', API_BASE || '(same-origin)', IS_DEVELOPMENT_MODE ? '(development)' : '(production)');

export default API_BASE;
export const API_BASE_VALID = true;
export const API_BASE_ERROR_MSG = '';
